<template>
    <div class="cancle-modal" @click.stop.prevent="handleClose(false)" @touchend.stop.prevent="handleClose(false)">
        <div class="main" >
            <div class="btn-1" @click.stop.prevent="handleClose(true)" @touchend.stop>取消投票</div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        handleClose(flag) {
            this.$emit('closeCancleModal',flag)
        }
    }

}
</script>
<style lang="less" scoped>
    .cancle-modal {
        position: fixed;
        z-index: 1001;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        .main {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 184px; /*px*/
            background: #FFFFFF;
            border-radius: 16px 16px 0px 0px; /*px*/
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 26px;/*px*/
            .btn-1 {
                flex: 1;
                height: 72px;/*px*/
                display: flex;
                align-items: center;
                justify-content: center;
                background: #f2f2f2;
            }
        }
    }
</style>